export default __webpack_public_path__ + "static/media/utjd_gant2024.f14f706b.png";